// import capture_mix from '@/mixins/capture_mix'
// mixins:[capture_mix],
// @click="capt_capture({ref:'ref_capture', clrBack:''#1e1e1e''})"

import html2canvas from 'html2canvas'

const capture_mix = {
  data() {
    return {
      capt_inProgress: false,
      // capt_inProgress: true,
      capt_contStyle: {},
    }
  },
  methods: {
    capt_capture({ el, id = 'capture', clrBack = '#1e1e1e' } = {}) {
      this.capt_inProgress = true
      const captureCont = el || document.getElementById(id)
      captureCont.classList.add('capture-in-progress')
      if (!captureCont) {
        console.warn('No element to capture')
        return
      }

      let { width, height } = captureCont.getBoundingClientRect()
      const maxWidth = 21.5 * 16
      if (width > maxWidth) {
        width = maxWidth
      }
      this.capt_contStyle = {
        width: `${width}px`,
        'max-width': `${width}px`,
        'min-width': `${width}px`,
        height: `${height}px`,
        'max-height': `${height}px`,
        'min-height': `${height}px`,
        overflow: 'hidden',
      }
      setTimeout(() => {
        const opts = {
          scrollX: -window.scrollX,
          scrollY: -window.scrollY,
          windowWidth: document.documentElement.offsetWidth,
          windowHeight: document.documentElement.offsetHeight,
          backgroundColor: clrBack,
        }
        html2canvas(document.getElementById(id), opts).then(canvas => {
          const link = document.createElement('a')
          link.id = 'capturelink'

          link.target = '_blank'
          link.setAttribute(
            'download',
            `GTOWizard_${this.formatDate(new Date().toISOString(), 'yyyy_MM_dd')}.png`,
          )
          link.setAttribute(
            'href',
            canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream'),
          )
          link.click()

          this.capt_inProgress = false
          this.capt_contStyle = {}

          if (captureCont) {
            captureCont.classList.remove('capture-in-progress')
          }
        })
      }, 222)
    },
  },
}

export default capture_mix
